var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccounts = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_accounting_2664946",
    width: 26.414,
    height: 33.176,
    viewBox: "0 0 26.414 33.176",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19191",
    "data-name": "Path 19191",
    d: "M40.362,17.633V13.024A1.024,1.024,0,0,0,39.338,12H26.024A1.024,1.024,0,0,0,25,13.024v4.609a1.024,1.024,0,0,0,1.024,1.024H39.338A1.024,1.024,0,0,0,40.362,17.633ZM26.024,13.024H39.338v4.609H26.024Z",
    transform: "translate(-21.928 -8.928)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19194",
    "data-name": "Path 19194",
    d: "M33.768,31.768a.375.375,0,0,1-.378.371H24.422V24.882h1.042a2.59,2.59,0,0,1,.236-1.034v0h-1.28V16.578h4.66l.482-1.037H14.038V1.408a.375.375,0,0,1,.378-.371H33.39a.375.375,0,0,1,.378.371V7.218a2.469,2.469,0,0,1,1.038-.44V1.408A1.413,1.413,0,0,0,33.39,0H14.416A1.413,1.413,0,0,0,13,1.408V31.768a1.413,1.413,0,0,0,1.416,1.408H33.39a1.413,1.413,0,0,0,1.416-1.408V24.657l-1.038,2.232ZM23.384,16.578v7.267H14.038V16.578Zm-9.345,15.19V24.882h9.345v7.257H14.416A.375.375,0,0,1,14.038,31.768Z",
    transform: "translate(-13 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19195",
    "data-name": "Path 19195",
    d: "M78.791,33.636l-3.336-1.548A.879.879,0,0,0,74.3,32.5L67.094,48.017a1.009,1.009,0,0,0-.094.434l.048,5.1a.5.5,0,0,0,.177.434c.166.1.371-.011.5-.118l3.99-3.217A1.019,1.019,0,0,0,72,50.287l7.2-15.51a.853.853,0,0,0-.417-1.141ZM68.029,49.1l2.461,1.231-2.43,1.959Zm3.19.45-3.008-1.5,5.426-11.683L76.7,37.75Zm5.909-12.724L74.069,35.43l1.091-2.35,3.048,1.415Z",
    transform: "translate(-52.875 -23.409)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccounts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Accounts.2cabba6c.svg";
export { ForwardRef as ReactComponent };